// API Configuration
// In production/Docker, this will be set via environment variable
// In development, use frontend/.env to set REACT_APP_API_URL
// Default is production URL (used by mobile apps)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://simplebabysleep.com';
